import classes from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Button, Card, Flex, Group, Image, NumberFormatter, Text, rem } from '@mantine/core';
export const GameInfoCard: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" radius={rem(5)} mt={{
    base: 20,
    md: 0
  }} p={{
    base: 10,
    sm: 20
  }}>
      <Flex direction={{
      base: 'column',
      sm: 'row'
    }} justify={{
      base: 'start',
      sm: 'space-between'
    }} gap={{
      base: 20,
      sm: 0
    }}>
        <Group gap={20}>
          <Image src="/assets/info/game_1.png" alt="game-info" w={69} h={69} />
          <Box>
            <Text fz="xs" tt="uppercase" c="var(--text-prime)" fw={700}>
              {i18n._('SWEET BONANZA')}
            </Text>
            <Text fz="xs" c="var(--text-dark)" tt="capitalize">
              {i18n._('Pragmatic Play')}
            </Text>
          </Box>
        </Group>
        <Flex justify={{
        base: 'space-between',
        sm: 'start'
      }} gap={25} align="center">
          <Box>
            <Text ta={{
            base: 'left',
            sm: 'right'
          }} fz={{
            base: 12,
            sm: 13
          }} fw={700} tt="uppercase" c="var(--text-dark)">
              {i18n._('PROFIT')}
            </Text>
            <Text ta={{
            base: 'left',
            sm: 'right'
          }} c="var(--text-green)" fz={{
            base: 24,
            sm: 20
          }} className={gunterzBold.className}>
              <NumberFormatter value={255.73} thousandSeparator="," decimalSeparator="." prefix="$" decimalScale={2} />
            </Text>
          </Box>
          <Button h={46} fz={12} classNames={{
          root: classes.root
        }}>
            {i18n._('PLAY NOW')}
          </Button>
        </Flex>
      </Flex>
    </Card>;
};